export default __webpack_public_path__ + "static/media/icons8-django.6d5d09ea.svg";